import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Container, Row, Col, Card, CardBody, Badge, Spinner, Label, Button } from 'reactstrap'
import moment from 'moment'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import DataTable from '../../../components/Template/Table/DataTable'
import { updateSolicitation, getPendingSolicitations } from '../../../store/ducks/humanResources'

class PendingSolicitations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subjectsFilter: null,
      reasonDialogIsOpen: false,
      statusFilter: [{
        value: '0',
        label: 'Em aberto',
      }],
    }
  }

  componentDidMount() {
    const { getPendingSolicitations } = this.props

    getPendingSolicitations(true)
  }

  formatAssunto = assunto => {
    switch (assunto) {
      case 'Atestado':
        return 'Ausência'
      case 'Despesa':
        return 'Despesa'
      case 'Férias':
        return 'Férias'
      case 'Retroativo':
        return 'Ponto retroativo'
      default:
        return null
    }
  }

  formatResumo = row => {
    switch (row.pend_assunto) {
      case 'Atestado':
        return `Período: ${moment(row.pend_dt_ini).format('DD/MM')} à ${moment(row.pend_dt_fim).format('DD/MM/YYYY')} - Tempo: ${row.pontoAtiv_tempo} - Justificativa: ${row.pend_justif}`
      case 'Despesa':
        return `${row.mov_desc} - R$ ${Math.abs(row.mov_vlr)}`
      case 'Férias':
        return `Período: ${moment(row.pend_dt_ini).format('DD/MM')} à ${moment(row.pend_dt_fim).format('DD/MM/YYYY')}`
      case 'Retroativo':
        return `Período: ${moment(row.pend_dt).format('DD/MM/YYYY')} - Tempo: ${row.pontoAtiv_tempo} - Justificativa: ${row.pend_justif}`
      default:
        return null
    }
  }

  formatStatus = status => {
    switch (status) {
      case '0':
        return <Badge className="badge-soft-info mr-1">Em aberto</Badge>
      case '1':
        return <Badge className="badge-soft-success mr-1">Aprovada</Badge>
      case '2':
        return <Badge className="badge-soft-danger mr-1">Recusada</Badge>
      default:
        return null
    }
  }

  render() {
    const {
      getPendingSolicitationsIsLoading, pendingSolicitations, updateSolicitationIsLoading,
    } = this.props.humanResources

    const { updateSolicitation } = this.props
    const { subjectsFilter, statusFilter, reasonDialogIsOpen } = this.state

    //const { isManager } = this.props.auth.user

    //if (!isManager) return <Redirect to="/" />

    const columns = [
      {
        label: 'ID',
        field: 'pend_id',
        sort: 'disabled',
      },
      {
        label: 'Data de solicitação',
        field: 'pend_dt_sol',
        sort: 'disabled',
      },
      {
        label: 'Assunto',
        field: 'pend_assunto',
        sort: 'disabled',
      },
      {
        label: 'Solicitante',
        field: 'pend_colaborador',
        sort: 'disabled',
      },
      {
        label: 'Resumo',
        field: 'resumo',
        sort: 'disabled',
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'disabled',
      },
      {
        label: 'Aceitar',
        field: 'accept_solicitation',
        sort: 'disabled',
      },
      {
        label: 'Recusar',
        field: 'reject_solicitation',
        sort: 'disabled',
      },
    ]

    let openSolicitations = []
    let filteredSolicitations = []
    if (!getPendingSolicitationsIsLoading && pendingSolicitations) {
      openSolicitations = pendingSolicitations.filter(solicitation => solicitation.pend_aprov === '0')
      console.tron.log('openSolicitations', openSolicitations)

      // Filter by Status
      if (statusFilter && statusFilter.length > 0) {
        const status = statusFilter.map(i => i.value)
        filteredSolicitations = pendingSolicitations.filter(solicitation => {
          if (solicitation.pend_aprov) {
            return status.some(substring => solicitation.pend_aprov.includes(substring))
          }
          return false
        })
      } else {
        filteredSolicitations = pendingSolicitations
      }

      // Filter by Subject
      if (subjectsFilter && subjectsFilter.length > 0) {
        const subjects = subjectsFilter.map(i => i.value)
        filteredSolicitations = filteredSolicitations.filter(solicitation => {
          if (solicitation.pend_assunto) {
            return subjects.some(substring => solicitation.pend_assunto.includes(substring))
          }
          return false
        })
      }
    }

    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Solicitações"
            breadcrumbItems={[]}
          />

          <Row>
            <Col className="mb-4" xl={4} lg={4} md={4} sm={4}>
              <Label>
                Filtrar por Status
              </Label>
              <Select
                isMulti
                placeholder="Status"
                defaultValue={[
                  {
                    value: '0',
                    label: 'Em aberto',
                  },
                ]}
                options={[
                  {
                    value: '0',
                    label: 'Em aberto',
                  },
                  {
                    value: '1',
                    label: 'Aprovada',
                  },
                  {
                    value: '2',
                    label: 'Recusada',
                  },
                ]}
                onChange={status => this.setState({ statusFilter: status })}
              />
            </Col>

            <Col className="mb-4" xl={4} lg={4} md={4} sm={4}>
              <Label>
                Filtrar por Assunto
              </Label>
              <Select
                isMulti
                placeholder="Assunto"
                options={[
                  {
                    value: 'Atestado',
                    label: 'Atestado',
                  },
                  {
                    value: 'Despesa',
                    label: 'Despesa',
                  },
                  {
                    value: 'Férias',
                    label: 'Férias',
                  },
                  {
                    value: 'Retroativo',
                    label: 'Retroativo',
                  },
                ]}
                onChange={subjects => this.setState({ subjectsFilter: subjects })}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  {getPendingSolicitationsIsLoading && (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-center py-3">
                        <Spinner />
                      </Col>
                    </Row>
                  )}

                  {!getPendingSolicitationsIsLoading && filteredSolicitations && (
                    <DataTable
                      data={{
                        columns,
                        rows: filteredSolicitations.map(row => ({
                          ...row,
                          pend_dt_sol: moment(row.pend_dt_sol).calendar(),
                          pend_id: (
                            <Link
                              to={{
                                pathname: `/gerencia/solicitacoes/${row.pend_id}`,
                                state: {
                                  solicitation: row,
                                  openSolicitations,
                                },
                              }}
                            >
                              {row.pend_id}
                            </Link>
                          ),
                          pend_assunto: (
                            <Link
                              to={{
                                pathname: `/gerencia/solicitacoes/${row.pend_id}`,
                                state: {
                                  solicitation: row,
                                  openSolicitations,
                                },
                              }}
                            >
                              {/* {this.formatAssunto(row.pend_assunto)} */}
                              {row.pend_assunto}
                            </Link>
                          ),
                          resumo: this.formatResumo(row),
                          status: this.formatStatus(row.pend_aprov),
                          accept_solicitation: (
                            <Button
                              type="button"
                              color="primary"
                              className="ml-3"
                              disabled={reasonDialogIsOpen || updateSolicitationIsLoading}
                              onClick={() => updateSolicitation({
                                type: 1,
                                solicitation: row,
                                simple: 1,
                              })}
                            >
                              Aprovar
                              {!reasonDialogIsOpen && updateSolicitationIsLoading && (
                              <Spinner size="sm" className="ml-2" />
                              )}
                            </Button>
                          ),
                          reject_solicitation: (
                            <Button
                              type="button"
                              color="danger"
                              disabled={reasonDialogIsOpen || updateSolicitationIsLoading}
                              onClick={() => this.setState({ reasonDialogIsOpen: true })}
                            >
                              Rejeitar
                            </Button>
                          ),
                        })),
                      }}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth, humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ getPendingSolicitations, updateSolicitation }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(PendingSolicitations)
